"use client"

import React from 'react';
import Link from "next/link";

const JobCard = ({ jobname, location, jobType, jobLevel, jobDescription, url }) => {

  return (
    <div className="bg-[#FAF9FE] shadow-md rounded-[20px] p-6 max-full">
      <h2 className="font-lato font-bold bg-custom-radial bg-clip-text text-transparent text-[20px] lg:text-[36px] mb-6 ">{jobname}</h2>
      <div className="lg:flex items-center text-sm text-gray-600 mb-8">
        <div className="flex items-center lg:mr-4 mt-4 lg:mt-0">
          <img src={"/images/jobLoc.svg"} className='mr-4'/>
          <span className='text-[#EF6717] font-lato font-bold text-[14px] lg:text-[28px] '>{location}</span>
        </div>
        <div className="flex items-center lg:mr-4 mt-4 lg:mt-0 -ml-1 lg:ml-0">
        <img src={"/images/jobType.svg"} className='mr-4'/>
          <span className='text-[#EF6717] font-lato font-bold text-[14px] lg:text-[28px]'>{jobType}</span>
        </div>
        <div className="flex items-center mt-4 lg:mt-0 -ml-2 lg:ml-0">
        <img src={"/images/jobLevel.svg"} className='mr-4'/>
          <span className='text-[#EF6717] font-lato font-bold text-[14px] lg:text-[28px]'>{jobLevel}</span>
        </div>
      </div>
      <p className="text-[14px] lg:text-[18px] mb-4 font-lato ">{jobDescription}</p>
     <Link href={url} target='_blank'>
      <button className="bg-[#EF6717] text-white px-4 py-2 rounded-[5px] hover:bg-orange-600 transition duration-300 lg:w-[260px] lg:h-[45px] text-[14px]">
        Apply Now
      </button>
      </Link>
    </div>
  );
};

export default JobCard;
